import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { ThumbnailList } from '../ThumbnailList';

import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../Accordion';
import { Tooltip, TooltipContent, TooltipTrigger } from '../Tooltip';

const StudyItem = ({
  date,
  description,
  numInstances,
  modalities,
  isActive,
  onClick,
  isExpanded,
  displaySets,
  activeDisplaySetInstanceUIDs,
  onClickThumbnail,
  onDoubleClickThumbnail,
  onClickUntrack,
  viewPreset = 'thumbnails',
  ThumbnailMenuItems,
  StudyMenuItems,
  StudyInstanceUID,
  onEditDescription,
}: withAppTypes) => {
  return (
    <Accordion
      type="single"
      collapsible
      onClick={onClick}
      onKeyDown={() => {}}
      role="button"
      tabIndex={0}
      defaultValue={isActive ? 'study-item' : undefined}
    >
      <AccordionItem value="study-item">
        <AccordionTrigger className={classnames('hover:bg-popover bg-secondary-dark group w-full rounded items-start')}>
          <div className="flex h-[40px] w-full flex-col justify-center gap-[2px] overflow-hidden">
            {/* Top Row: Calendar + Date (left) | Arrow (right - auto by AccordionTrigger) */}
            <div className="flex w-full items-center justify-between">
              <div className="flex items-center gap-[6px]">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10 1.5H2C1.72386 1.5 1.5 1.72386 1.5 2V10C1.5 10.2761 1.72386 10.5 2 10.5H10C10.2761 10.5 10.5 10.2761 10.5 10V2C10.5 1.72386 10.2761 1.5 10 1.5Z" stroke="white" strokeWidth="0.75" fill="none"/>
                  <path d="M8.25 0.75V2.25M3.75 0.75V2.25M1.5 3.75H10.5" stroke="white" strokeWidth="0.75" strokeLinecap="round"/>
                </svg>
                <Tooltip>
                  <TooltipContent>{date}</TooltipContent>
                  <TooltipTrigger className="w-full" asChild>
                    <div className="text-[12px] text-white whitespace-nowrap">{date}</div>
                  </TooltipTrigger>
                </Tooltip>
              </div>
            </div>

            {/* Bottom Row: Modality • Description (left) | Count (right) */}
            <div className="flex w-full items-center justify-between pl-[18px]">
              <div className="flex items-center gap-[6px] min-w-0 flex-1">
                <div className="text-[11px] text-muted-foreground whitespace-nowrap">{modalities?.substring(0, 2)}</div>
                <div className="text-muted-foreground">•</div>
                <Tooltip>
                  <TooltipContent>{description}</TooltipContent>
                  <TooltipTrigger className="min-w-0" asChild>
                    <div className="text-[11px] text-muted-foreground truncate">{description}</div>
                  </TooltipTrigger>
                </Tooltip>
              </div>
              <div className="text-[11px] text-muted-foreground ml-2 whitespace-nowrap">{numInstances}</div>
            </div>
          </div>
        </AccordionTrigger>
        <AccordionContent
          onClick={event => {
            event.stopPropagation();
          }}
        >
          {isExpanded && displaySets && (
            <ThumbnailList
              thumbnails={displaySets}
              activeDisplaySetInstanceUIDs={activeDisplaySetInstanceUIDs}
              onThumbnailClick={onClickThumbnail}
              onThumbnailDoubleClick={onDoubleClickThumbnail}
              onClickUntrack={onClickUntrack}
              viewPreset={viewPreset}
              ThumbnailMenuItems={ThumbnailMenuItems}
              onEditDescription={onEditDescription}
            />
          )}
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};

StudyItem.propTypes = {
  date: PropTypes.string.isRequired,
  description: PropTypes.string,
  modalities: PropTypes.string.isRequired,
  numInstances: PropTypes.number.isRequired,
  isActive: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  isExpanded: PropTypes.bool,
  displaySets: PropTypes.array,
  activeDisplaySetInstanceUIDs: PropTypes.array,
  onClickThumbnail: PropTypes.func,
  onDoubleClickThumbnail: PropTypes.func,
  onClickUntrack: PropTypes.func,
  viewPreset: PropTypes.string,
  StudyMenuItems: PropTypes.func,
  StudyInstanceUID: PropTypes.string,
  onEditDescription: PropTypes.func,
};

export { StudyItem };
